import { createIcon } from '@chakra-ui/icons'

const VideoIcon = createIcon({
  viewBox: '0 0 77.9 86.9',
  path: (
    <g transform="translate(5311 -4734.065)">
      <path
        d="M-5242.5 4817.5h-59c-2.5 0-4.5-2-4.5-4.5v-71c0-2.5 2-4.5 4.5-4.5h44.4l19.1 17.3v58.2c0 2.5-2.1 4.5-4.5 4.5z"
        fill="#FFFFFF"
      />
      <path
        d="M-5242.5 4817c2.2 0 4-1.8 4-4v-58l-18.8-17h-44.2c-2.2 0-4 1.8-4 4v71c0 2.2 1.8 4 4 4h59m0 1h-59c-2.8 0-5-2.2-5-5v-71c0-2.8 2.2-5 5-5h44.6l19.4 17.6v58.4c0 2.8-2.3 5-5 5z"
        fill="#E1E4EA"
      />
      <path
        d="M-5237.5 4767h-69v-25c0-2.8 2.2-5 5-5h45.6l18.4 17.5v12.5z"
        fill="#658091"
      />
      <path
        d="M-5255.8 4737.1v9.9s-.4 7.4 7.8 7.5 10.4 0 10.4 0l-18.2-17.4z"
        opacity=".6"
        fill="#FFFFFF"
      />
      <text
        transform="translate(-5299.533 4756.032)"
        fontSize="12"
        fontFamily="ArialMT"
        fill="#F7FAFC"
      >
        VIDEO
      </text>
      <path
        fill="#E1E4EB"
        d="M-5272 4789.9c-4.2 0-7.5 3.4-7.5 7.5s3.4 7.5 7.5 7.5 7.5-3.4 7.5-7.5-3.4-7.5-7.5-7.5zm0 13.6c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6z"
      />
      <path
        fill="#E1E4EB"
        d="M-5272.9 4794.8c-.3-.2-.8-.1-1 .2-.1.1-.1.2-.1.4v4.1c0 .4.3.7.7.7.1 0 .3 0 .4-.1l3.3-2.1c.3-.2.4-.7.2-1-.1-.1-.1-.2-.2-.2l-3.3-2z"
      />
      <path
        fill="#E1E4EB"
        d="m-5259.3 4784.2-7.8-7.8c-.5-.5-1.2-.8-1.8-.8h-14c-.7 0-1.4.3-1.8.8-.5.5-.8 1.2-.8 1.8v28.5c0 1.4 1.2 2.6 2.6 2.6h21.8c1.4 0 2.6-1.2 2.6-2.6V4786c0-.6-.3-1.3-.8-1.8zm-1.5.7h-5.8c-.6 0-1.2-.5-1.2-1.2v-5.7l7 6.9zm-.4 23h-21.8c-.6 0-1.1-.5-1.1-1.1v-28.5c0-.6.5-1.1 1.1-1.1h13.6v6.5c0 1.5 1.2 2.7 2.7 2.7h6.5v20.4c.1.6-.3 1.1-1 1.1z"
      />
    </g>
  ),
})

export default VideoIcon
